import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from '../utils/analytics'

/**
 * AnalyticsTracker
 *
 * Mounted once at the Router root. On every route change it sends a
 * GA4 `page_view` event with the new path, title and full URL.
 *
 * Auto page_view is disabled in public/index.html (`send_page_view: false`)
 * so this component is the *only* source of page_view events. That keeps
 * the data clean and avoids double-counting between the initial HTML
 * load and the first React render.
 */
const AnalyticsTracker = () => {
  const location = useLocation()

  useEffect(() => {
    // Wait a tick so react-helmet has updated <title> before we read it.
    const t = window.setTimeout(() => {
      trackPageView(location.pathname + location.search)
    }, 0)
    return () => window.clearTimeout(t)
  }, [location.pathname, location.search])

  return null
}

export default AnalyticsTracker
